import { IState } from "./index";
import Vue from "vue";
export default {
  state(state: IState, newState: IState) {
    state = { ...newState };
  },
  setWeather(state: IState, data: object[]) {
    Vue.set(state, "weather_list", data);
  },
  setCurrent(state: IState, data: object) {
    Vue.set(state, "current", data);
  },
};
